import { render, staticRenderFns } from "./PxCamposCompraItemTableUseallSetup.vue?vue&type=template&id=6f87cce5&"
import script from "./PxCamposCompraItemTableUseallSetup.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableUseallSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports